import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dictionary_acctype'

  static get fields () {
    return {
      id: new UUID(),
      tag: new STRING(),
      desc: new STRING(),
      enqhours: new STRING(),
      trackingdays: new STRING(),
      callbacktime: new STRING(),
      css: new STRING()
    }
  }
}
